"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Radio_1 = __importDefault(require("../radio/Radio"));
require("../../scss/_radio-list-item.scss");
var RadioListItemGroup_1 = require("../radio-list-item-group/RadioListItemGroup");
/**
 * @component RadioListItem
 *
 * @example
 *  <RadioListItem
 *   id="balance"
 *   name="makePaymentType"
 *   radioLabel="Balance"
 *   value="balance"
 *   checked={someBool}
 *   onChange={formik.handleChange}
 *   endOfRowLabel="$1000"
 * />
 *
 * @param {number | string} id id of the component in the form
 * @param {string} name for Formik purposes
 * @param {string} radioLabel label to show up next to the radio
 * @param {string} value current value
 * @param {function} onChange fn for onChange
 * @param {boolean} checked is this radio button selected
 * @param {number} marginTop margin on the top of the radio item
 * @param {number} marginBottom  margin on the bottom of the radio item
 * @param {string} secondaryLabel middle of the row text
 * @param {string} tertiaryLabel last 1/3 of the row text
 * @param {boolean} isShaded is the row shaded
 * @param {string} endOfRowLabel end of the row text
 * @param {PfrRowOutlineColor} selectColor color to outline the row in when selected
 *
 */
var RadioListItem = function (props) {
    var id = props.id, name = props.name, radioLabel = props.radioLabel, value = props.value, onChange = props.onChange, _a = props.checked, checked = _a === void 0 ? false : _a, secondaryLabel = props.secondaryLabel, tertiaryLabel = props.tertiaryLabel, isShaded = props.isShaded, endOfRowLabel = props.endOfRowLabel, selectColor = props.selectColor;
    var getClassName = function () {
        if (isShaded) {
            if (selectColor && selectColor === RadioListItemGroup_1.PfrRowOutlineColor.success) {
                return 'checked-success item';
            }
            else if (selectColor === RadioListItemGroup_1.PfrRowOutlineColor.error) {
                return 'checked-error item';
            }
        }
        if (isShaded) {
            return 'item';
        }
        return '';
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Grid, { container: true, className: getClassName(), direction: "row", justifyContent: "space-around", alignItems: "center" },
            react_1.default.createElement(material_1.Grid, { item: true, xs: endOfRowLabel ? 6 : 3 },
                react_1.default.createElement(material_1.Box, { justifyContent: "flex-start", className: "pt-1 pl-1" },
                    react_1.default.createElement(Radio_1.default, { id: id, name: name, label: radioLabel, value: value, checked: checked, onChange: onChange }))),
            secondaryLabel && tertiaryLabel && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Grid, { item: true, xs: 5 },
                    react_1.default.createElement(material_1.Typography, null, secondaryLabel)),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 4 },
                    react_1.default.createElement(material_1.Typography, null, tertiaryLabel)))),
            endOfRowLabel && (react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(material_1.Box, { display: "flex", justifyContent: "flex-end" },
                    react_1.default.createElement(material_1.Typography, { variant: "subtitle2" }, endOfRowLabel)))))));
};
exports.default = RadioListItem;
